<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { JazelAppContainer } from '@jazel/jazel-vuetify';
import { useAccountStore } from '@/stores/accountStore';

const accountStore = useAccountStore();
const route = useRoute();

const adminTab = computed(() =>
  route.name === 'admin-missing-trims' ? 'missing-trims' : 'settings',
);
</script>

<template>
  <JazelAppContainer
    app-name="Vue Door"
    @update:account-settings="accountStore.setAccountSettings($event)"
    @update:session-token="accountStore.setSessionToken($event)"
    @update:is-client-user="accountStore.setIsClientUser($event)"
    @update:product-settings="accountStore.setProductSettings($event)"
  >
    <v-container fluid class="px-2 px-sm-4 py-2">
      <v-tabs :model-value="adminTab" color="primary" class="mb-2">
        <v-tab value="settings" :to="{ name: 'admin-settings' }">Settings</v-tab>
        <v-tab value="missing-trims" :to="{ name: 'admin-missing-trims' }"> Missing Trims </v-tab>
      </v-tabs>
      <router-view />
    </v-container>
  </JazelAppContainer>
</template>

<style scoped>
:deep(.v-tab) {
  text-transform: none !important;
}

.v-container {
  overflow-x: hidden;
  max-width: 100%;
}
</style>
